"use strict";
const React = require('react');
const m = require('../models');
const format = require('../utils/format');
const taskUtils = require('../utils/task');
const GoalIcon_1 = require('./GoalIcon');
const Interval_1 = require('./Interval');
exports.RunningTaskDuration = Interval_1.default(class extends React.Component {
    render() {
        const taskTime = taskUtils.getTaskTime(this.props.task);
        return (React.createElement("span", {style: this.props.style}, format.timeTracked(taskTime)));
    }
}
);
exports.RunningGoalDuration = Interval_1.default(class extends React.Component {
    render() {
        const task = this.props.task;
        const now = new Date();
        if (!task.goal || task.goal.type === 0 /* NONE */ || task.goal.duration === 0 || !task.goal.repeats[now.getDay()]) {
            return null;
        }
        const color = taskUtils.getGoalStatusColor(task);
        const message = taskUtils.getGoalMessage(task);
        const goalIcon = GoalIcon_1.buildGoalIcon({ task });
        return (React.createElement("div", {style: style.RunningGoalDuration.root}, 
            goalIcon, 
            React.createElement("span", {style: Object.assign({}, this.props.style, { color })}, message)));
    }
}
);
const style = {
    RunningGoalDuration: {
        root: {
            alignItems: 'center',
            display: 'flex',
        },
    },
};



/** WEBPACK FOOTER **
 ** ./src/components/RunningDuration.tsx
 **/